import { get, writable } from "svelte/store";

export const to = function(promise) {
    return promise
        .then(
            data => {
                if(data == 'TypeError: Failed to fetch'){
                  return [{
                    status:'cors'
                  },null]
                }
                if (
                    data.error ||
                    data.status == 401 ||
                    data.status == 403 ||
                    data.status == 405 ||
                    data.status == 400 ||
                    data.status == 500 ||
                    data.status == 404
                ) {
                    return [data, null];
                }
                return [null, data];
            },
            error => {
                return [error];
            }
        )
        .catch(err => [err]);
};

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            // Does this cookie string begin with the name we want?
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const HeaderFactory = function(data) {
    let header = {
        Accept: "application/json",
    };
    if(this._contentType){
      if(this._contentType != "AUTO"){
        header = {
            ...header,
            "Content-Type": this._contentType
        }
      }
    }else{
        header = {
            ...header,
        }
        if(data instanceof FormData){
          //header["Content-Type"] = "multipart/form-data";
        }else{
          header["Content-Type"] = "application/json";
        }

    }
    let token = API._authToken && get(API._authToken);
    if(token) {
        if(token.length > 40){
            header.Authorization = "JWT " + token;
        }else{
            header.Authorization = "Token " + token;
        }
    }else{
      header['X-CSRFToken'] = getCookie('csrftoken')
    }
    return header;
};

function getValue(key,data){
    if(data instanceof FormData) {
        return data.get(key)
    }else{
        return data[key]
    }
}

function removeKey(key,data){
    if(data instanceof FormData) {
        delete data.delete(key);
    }else{
        delete data[key];
    }
}

function queryParams(params) {
    let keys = []
    if(params instanceof FormData){
        keys = params.keys()
    }else{
        keys = Object.keys(params);
    }
    return keys.map(k => encodeURIComponent(k) + "=" + encodeURIComponent(getValue(k,params))) .join("&");
}

function fillInParsed(url, data={}) {
    if(this._varSplitter){
        let items = [...url.matchAll(this._varSplitter)];
        for(var i=0;i<items.length;i++){
            let item = items[i]; // match

            let key = item[1];
            if(data[key]){
                url = url.split(item[0]).join(data[key])
            }
        }
        return url;
    }else{
        let items = url.split('/');
        for (var i = 0; i < items.length; i++) {
            let item = items[i];
            if (item.indexOf(":") != -1) {
                item = item.replace(":", "");
                if(data instanceof FormData){
                  if(data.get(item)) {
                    items[i] = data.get(item)
                    removeKey(item,data)
                  }
                }else{
                  items[i] = data[item] || null;
                  removeKey(item,data)
                }

            }
        }
        return items.join("/").split('//').join('/');
    }
}

const APIFactory = function(service_url,useAPI=true) {

    function getHostURL() {
      return this._host ? this._host : '/';
    }

    let fetchMethod = async function(service, data, method) {
        let url = service;
        let apiURL = (this._host != undefined) ? this._host : getHostURL.call(API);
        let projectURL = this.namespace && this.project ? `/${this.project}/` : "";
        let api = useAPI ? 'api/':'';
        let serviceURL = "";
        if(!this._external){
            url = `${api}${projectURL}${service}/`;
            url = fillInParsed.call(this, url, data);
            serviceURL = apiURL + url;
        }else {
            serviceURL = fillInParsed.call(this,url, data);
        }
        if (method == "GET") {
            serviceURL +=
                (url.indexOf("?") === -1 ? "?" : "&") + queryParams(data || {});
            return await fetch(serviceURL, {
                method: method,
                headers: HeaderFactory.call(this),
            }).then(async response => {
                if (response.ok) {
                    let json = await response.json();
                    return json;
                } else {
                    return { status: response.status, data: response };
                }
            });
        }
        return await fetch(serviceURL, {
            method: method,
            headers: HeaderFactory.call(this,data),
            body: (data instanceof FormData) ? data : JSON.stringify(data),
        }).then(async response => {
            if(response.status == 204) { //  204 No-Content usually used for delete
                return {"success":true};
            }else {
                if (response.ok) {
                    let json = await response.json();
                    return json;
                } else {
                    let data = await response.json()
                    return { status: response.status, data: data  };
                }
            }

        });
    }

    let api = {
        namespace: true,
        project:undefined,
        _host: __host__,//'http://localhost:8000/',//'https://impactfx.club/',//
        _contentType:undefined,
        _external:false,
        useNameSpace: function(use) {
            this.namespace = use;
            return this;
        },
        contentType:function(value){
            this._contentType = value;
            return this;
        },
        external:function(value){
            this._external = value;
            return this;
        },
        host: function(value) {
            this._host = value;
            return this;
        },
        varSplitter:function(value){
            this._varSplitter = value;
            return this;
        },
        useProject: function(project) {
            this.project = project;
            return this;
        },
        get: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "GET");
        },
        create: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "POST");
        },
        post: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "POST");
        },
        update: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "PATCH");
        },
        delete: async function(data,overwriteServiceUrl) {
            return await fetchMethod.call(this, overwriteServiceUrl || service_url, data, "DELETE");
        },
    };
    api.serviceUrl = service_url;
    return api;
};

export const API = {
    _host:'',
    _authToken:null,
    host:function(value){
        this._host = value;
        return this;
    },
    version: null, //__version__,
    setAuthTokenStore: function(store) {
        this._authToken = store;
        return this;
    },
    setAPIOrgStore:function(org){
      this._org = org
      return this;
    },
    setVersion:function(version){
        this.version = version;
        return this
    },
    service: APIFactory,
};

export const CollectionORM = function(service, data = [], id="id",customFuncs={}) {
    const collectionStore = writable(data);
    const idKey = id;
    const { subscribe, set, update } = collectionStore;

    function getData(){
        return get(collectionStore);
    }

    async function createItem(data, updateCollection=true) {
        let [error, response] = await to(service.create(data));
        if (error) {
            return error
        }
        if(updateCollection) {
          update(collection => {
              if(collection && collection.hasOwnProperty('results')){
                  collection.results = [...collection.results, response];
                  collection.loaded = true;
              }else if(Array.isArray(collection)){
                  collection = [...collection, response];
                  collection.loaded = true;
              }else{
                  collection = response;
                  collection.loaded = true;
              }
              return collection;
          });
        }

        return response;
    }

    function findItem(id) {
        return get(collectionStore).filter(item => item[idKey])[0];
    }

    async function updateItem(data,updateCollection=true) {
        let id = data[idKey];
        data = JSON.parse(JSON.stringify(data));
        let [error, response] = await to(service.update(data));
        if (error) {
            return error;
        }

        if(updateCollection){
            update(collection => {
                if(collection && collection.hasOwnProperty('results')){
                    collection = collection.results.map(item => {
                        if (item[idKey] == id) {
                            return response;
                        }
                        return item;
                    });
                }else if (Array.isArray(collection)) {
                  let data = collection.map(item => {
                      if (item[idKey] == id) {
                          return response;
                      }
                      return item;
                  });
                  data.loaded = true;
                  return data;
                } else {
                    return response;
                }

                return collection;
            });
        }

        return response;
    }

    function empty(){
        let data = get(collectionStore);
        if(data && data.hasOwnProperty('results')){
            return data.results.length == 0;
        }else if(Array.isArray(data) && !data.length){
            return true;
        }else if (!Array.isArray(data) && !data){
            return true;
        }
        return false;
    }

    async function deleteItem(data) {
        let id = data[idKey];
        let [error, response] = await to(service.delete(data));
        if (error) {
            return error;
        }
        update(collection => {
            if(collection && collection.hasOwnProperty('results')){
                collection.results = collection.results.filter(item => item[idKey] != id);
                return collection;
            } else if (Array.isArray(collection)) {
                let data = collection.filter(item => {
                  return item[idKey] != id
                });
                data.loaded = true;
                return data;
            } else {
                collection = null;
            }
        });
        return response;
    }

    async function refresh(params,force=false){
        // backwards compatible with 1.0.13
        if(typeof params == 'boolean'){
          force = params;
          params = {}
        }



        if(!force && !empty()) return get(collectionStore);

        let data = get(collectionStore)
        data ? data.loaded = false : data
        set(data);

        let [error,response] = await to(service.get(params));
        if(error){
            return error
        }
        response.loaded = true;
        set(response);
        return response;
    }

    async function loadById(id){
        let data = {}
        data[idKey] = id;
        let [error, response] = await to(service.get(data));
        if (error) {
            return error;
        }
        update(collection => {
            if(collection && collection.hasOwnProperty('results')){
                collection = collection.results.map(item => {
                    if (item[idKey] == id) {
                        return response;
                    }
                    return item;
                });
            }else if (Array.isArray(collection)) {
                collection = collection.map(item => {
                    if (item[idKey] == id) {
                        return response;
                    }
                    return item;
                });
            }else{
                collection = response;
                collection.loaded = true
            }
            return collection;
        });
        return response;
    }

    return {
        proxy:null,
        set,
        subscribe: subscribe,
        create: createItem,
        update: updateItem,
        $$update:update,
        delete: deleteItem,
        find:findItem,
        getData,
        refresh,
        loadById,
        ...customFuncs,
        service
    };
};
